import findBySlug from "./find-by-slug";

const findVolume = (container, route) =>
  findBySlug(container?.volumes, route.params.volumeSlug);

export default function resolveRoutedVolume(route, { state, getters }) {
  if (!getters.containerLoaded) {
    return null;
  }

  // Once the container is loaded, we an determine if the volume slug
  // route parameter matches one of the defined volumes. However,
  // if there is no volume slug parameter, then we can only
  // return null and let the app auto-determine a fallback volume.
  if (!route.params?.volumeSlug) {
    return null;
  }

  // If a volume slug route parameter is defined, use the parameter to match
  // one of the defined volumes. If none matches, fall back to an auto volume.
  return findVolume(state.container, route);
}
